module.exports = __webpack_public_path__ + "static/img/zscq.1ff1f13f.jpg";